<template>
	<span :class="['level', { 'level--has-tooltip': tooltip }]">
		<span :class="['level__color', `level__color--${level}`]"></span>
		<span class="level__text"><slot></slot></span>
		<span v-if="tooltip != ''" class="level__tooltip">
			<p>{{ tooltip }}</p>
		</span>
	</span>
</template>

<script>
export default {
	name: 'LevelLabel',
	props: {
		level: {
			type: Number,
			default: 0
		},
		tooltip: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped lang="scss">
.level {
	display: inline-block;
	border: 1px solid rgba(42, 62, 97, 0.2);
	border-radius: 3px;
	background-color: #ffffff;
	box-shadow: inset 0 0 1px 0 rgba(0, 0, 0, 0.2);
	color: $colorPrimary;
	font-family: Saira;
	font-size: 13px;
	font-weight: 500;
	letter-spacing: 0;
	line-height: 21px;
	//margin: 0 10px 0 0;
	margin: 8px 10px 0 0;
	padding: 2px 10px 4px;
	position: relative;

	&--has-tooltip {
		cursor: help;
	}

	&__text {
		display: inline-block;
		vertical-align: middle;
		line-height: 18px;
	}

	&__tooltip {
		display: block;
		position: absolute;
		top: 125%;
		left: -100%;
		width: 240px;
		padding: 7px 15px;
		z-index: 1;
		background: $colorWhite;
		border: 1px solid #a1a1a1;
		visibility: hidden;
		opacity: 0;
		transition: visibility 0s, opacity 0.3s linear;
		@include for-tablet-landscape-up {
			top: calc(-50% + 6px);
			left: 110%;
		}
		p {
			font-size: 12px;
		}
	}

	&__color {
		display: inline-block;
		height: 12px;
		width: 12px;
		border-radius: 2px;
		margin: 0 8px 0 0;
		vertical-align: middle;
		&--1,
		&--2048 {
			background-color: #64c7bc;
		}
		&--2,
		&--2049 {
			background-color: #04befb;
		}
		&--3,
		&--2050 {
			background-color: #b9003c;
		}
		&--2051 {
			background-color: #000;
		}
		&--2063 {
			background: repeating-linear-gradient(
				-45deg,
				#000,
				#000 2px,
				#fff 2px,
				#fff 4px
			);
		}
	}

	&:hover {
		.level__tooltip {
			visibility: visible;
			opacity: 1;
		}
	}
}
</style>
